import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const RecoupAccountPassthroughs = () => {
  const create = (recoup_account_id, split_id) =>
    AuthAxios.post(`${DataApiUrl}/admin/recoupAccounts/${recoup_account_id}/passthroughs`, {
      stakeholder_track_split_id: split_id,
    })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });
  const del = id =>
    AuthAxios.delete(`${DataApiUrl}/admin/recoupAccountPassthroughs/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });
  return {
    create,
    del,
  };
};
export default RecoupAccountPassthroughs;
